import {Injectable} from 'ng-metadata/core';
import { Component, Inject, Input, OnInit} from 'ng-metadata/core';

@Injectable()
export class TagsListService {

    constructor() {
        
    }    
    
    
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/tags/tagsList/tagsList.service.ts